
import { getQuestions } from "../authentication/authentication.services";
import { addQuestions, commentDoc, createPastQuestion, deleteDocumentRecord, deleteFile, deleteHNDQuestionById, deleteTutorialById, getAllEbboks, getAllNotes, getAllPastQuestions, getAllprojects, getAllUsers, getAllVideos, getExamByField, getExamById, getNoteById, getPastQuestionById, getPostComments, getTutorial, getTutorialById, likeDoc, saveDocument, subscribeToHND, subscribeUser, updateDocument, updateExamById, updatePastQuestion,  updateTutorial, uploadDocument, uploadExamFile, uploadTutorial } from "./documents.services";

export const getAllLectureNotes = async () => {
    try {
        const response = await getAllNotes();
        const res = await response.json();
        console.log(res);
        return res;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

export const getAllResearchProjects = async () => {
    try {
        const response = await getAllprojects();
        const res = await response.json();
        return res
    } catch (e) {
        console.log({ error: `Internal server error: ${e}` });
    }
}

export const loadAllEbooks = async () => {
    try {
        const response = await getAllEbboks();
        const res = await response.json();
        return res
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

export const loadAllVideos = async () => {
    try {
        const response = await getAllVideos();
        const res = await response.json();
        return res;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}


export const loadAllQuestions = async () => {
    try {
        const response = await getQuestions();
        const res = await response.json();
        console.log({ questions: res })
        return res;

    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

export const loadAllUsers = async (token) => {
    try {
        const response = await getAllUsers(token);
        const res = await response.json();
        return res;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

export const uploadFile = async (data) => {
    try {
        const response = await saveDocument(data);
        const resp = await response.json();
        console.log(resp);
        return resp.url;
    } catch (error) {
        console.log({ error })
    }
}

/** Upload a pdf document */
export const uploadPublication = async (token, data) => {
    try {
        const url = await uploadFile(data);
        const newData = { ...data, document: url }
        const response = await uploadDocument(token, newData);
        const resp = await response.json();
        return resp;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

export const createLesson = async (token, data) => {
    try {
        //console.log(data);
        const url = await uploadFile(data);
        const newData = { ...data, video: url }
        const response = await uploadTutorial(token, newData);
        const resp = await response.json();
        console.log(resp);
        return resp;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

/** upload tutorial */
export const createTutorial = async (token, data) => {
    try {
        const url = await uploadFile(data);
        const newData = { ...data, pdfFile: url }
        const response = await uploadExamFile(token, newData);
        const resp = await response.json();
        console.log(resp);
        return resp;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

/** add question to tutorial */
export const addTutorialQuestion = async (token, data) => {
    try {
        const response = await addQuestions(token, data);
        const resp = await response.json();
        return resp;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

/** Get tutorial by field */
export const getTutorialByField = async (field) => {
    try {
        const response = await getExamByField(field);
        const data = await response.json();
        return data;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

export const getTutorialsByField = async (field) => {
    try {
        const response = await getTutorial(field);
        const data = await response.json();
        return data;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

/** Get tutorial by id */
export const loadTutorialById = async (id) => {
    try {
        const response = await getExamById(id);
        const res = await response.json();
        return res;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

/** Load lesson by id */
export const loadLessonById = async (id) => {
    try {
        const response = await getTutorialById(id);
        const res = await response.json();
        return res;
    } catch (error) {
        console.log({ error });
    }
}

/**update tutorial */
export const updateTutorialById = async (token, data, id) => {
    try {
        if (data?.document) {
            const delStatus = await deleteFileFromServer(data?.oldFile);
            if (delStatus === 200) {
                const filePath = await uploadFile(data);
                const uploadData = { ...data, pdfFile: filePath };
                const response = await updateTutorial(token, uploadData, id);
                const resp = await response.json();
                return resp;
            }else{
                return {
                    error: 'Failed to delete old file from server. Update failed!'
                }
            }
        }
        const response = await updateTutorial(token, data, id);
        const resp = await response.json();
        return resp;
    } catch (error) {
        console.log({ error });
    }
}

/** add answer file to exam */
export const addAnswerFile = async (id, token, data) => {
    try {
        const url = await uploadFile(data);
        const newData = { answer: url }
        const response = await updateExamById(id, token, newData);
        const resp = await response.json();
        console.log(resp);
        return resp;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}


export const getCommentsByPostId = async (id) => {
    try {
        const response = await getPostComments(id);
        const res = await response.json();
        return res;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

export const commentPublication = async (id, token, comment) => {
    try {
        const response = await commentDoc(id, token, comment);
        const res = await response.json();
        return res;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

/** delete any document from server */
export const deleteFileFromServer = async (fileUrl) => {
    try {
        const response = await deleteFile(fileUrl);
        const status = response.status;
        return status;
    } catch (e) {
        console.log({ error: e })
    }
}

/** update document */
export const updatePublication = async (id, token, data) => {
    try {
        const url = await uploadFile(data);
        const newData = { ...data, document: url }
        console.log(newData);
        const response = await updateDocument(id, token, newData);
        const res = await response.json();
        await deleteFileFromServer(data.fileUrl);
        return res;
    } catch (e) {
        console.log({ error: e })
    }
}

/** subscribe to tutorials */
export const userSubscription = async (token, email) => {
    try {
        const response = await subscribeUser(token, email);
        const res = await response.json();
        return res;
    } catch (e) {
        console.log({ error: e })
    }
}

/** subscribe to hnd past questions */
export const userHNDSubscription = async (token, email) => {
    try {
        const response = await subscribeToHND(token, email);
        const res = await response.json();
        return res;
    } catch (e) {
        console.log({ error: e })
    }
}


export const likeDocument = async (id, token) => {
    try {
        const response = await likeDoc(id, token);
        const res = await response.json();
        console.log(res);
        return res;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

export const loadById = async (id) => {
    try {
        const response = await getNoteById(id);
        const res = await response.json();
        return res;
    } catch (e) {
        console.log({ error: `Internal error: ${e}` });
    }
}

export const questionUpdate = async (token, data, id) => {
    
}

export const deleteDocument = async (id, token, fileUrl) => {
    try {
        const response = await deleteDocumentRecord(id, token);
        const resp = await response.json();
        await deleteFileFromServer(fileUrl);
        return resp;
    } catch (e) {
        console.log({ error: `Internal error! ${e}` })
    }
}


/*########################## HND ######################################### */

export const createNewQuestion = async (data, token) => {
    try {
        const url = await uploadFile(data);
        const newData = { ...data, pdfFile: url }
        const response = await createPastQuestion(newData, token);
        const res = await response.json();
        return res;
    } catch (error) {
        console.log({ error });
    }
}

/** load past question */
export const getPastQuestion = async (id) => {
    try {
        const response = await getPastQuestionById(id);
        const res = await response.json();
        return res;
    } catch (error) {
        console.log({ error })
    }
}

/** get all past questions */
export const loadAllPastQuestions = async (field) => {
    try {
        const response = await getAllPastQuestions(field);
        const data = await response.json();
        console.log(data);
        return data;
    } catch (error) {
        console.log({ error });
    }
}

/** update past question */
export const updateHNDQuestion = async (id, token, data) => {
    try {
        if (data?.document) {
            await deleteFileFromServer(data?.oldFile);
            const url = await uploadFile(data);
            const newData = { ...data, pdfFile: url }
            const response = await updatePastQuestion(id, token, newData);
            const res = await response.json();
            return res;
        } else {
            const response = await updatePastQuestion(id, token, data);
            const res = await response.json();
            return res;
        }
    } catch (error) {
        console.log({ error });
    }
}

/** delete past question by id */
export const deletePastQuestion = async (id, fileUrl, token) => {
    try {
        await deleteFileFromServer(fileUrl)
        const response = await deleteHNDQuestionById(id, token);
        const res = await response.json();
        return res;
    } catch (error) {
        console.log({ error });
    }
}

/** dlete Tutorial by id */
export const deleteTutorial = async (id, fileUrl, token) => {
    try {
        await deleteFileFromServer(fileUrl)
        const response = await deleteTutorialById(id, token);
        const res = await response.json();
        return res;
    } catch (error) {
        console.log({ error });
    }
}